import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import { FilterOptions } from '../types';

interface FilterPanelProps {
  onFilterChange: (filters: FilterOptions) => void;
  onReset: () => void;
}

const FilterPanel = ({ onFilterChange, onReset }: FilterPanelProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState<FilterOptions>({
    category: 'all',
    accuracy: 0,
    deployment: 'all',
    integration: 'all'
  });

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'retail', label: 'Retail Analytics' },
    { value: 'traffic', label: 'Traffic Management' },
    { value: 'security', label: 'Security Solutions' },
    { value: 'business-intelligence', label: 'Business Intelligence' }
  ];

  const deploymentOptions = [
    { value: 'all', label: 'Any Timeline' },
    { value: 'immediate', label: 'Immediate (1-2 weeks)' },
    { value: 'short', label: 'Short (2-4 weeks)' },
    { value: 'medium', label: 'Medium (1-2 months)' },
    { value: 'long', label: 'Long (2+ months)' }
  ];

  const integrationOptions = [
    { value: 'all', label: 'All Integrations' },
    { value: 'cloud', label: 'Cloud Platforms' },
    { value: 'erp', label: 'ERP Systems' },
    { value: 'crm', label: 'CRM Systems' },
    { value: 'iot', label: 'IoT Devices' }
  ];

  const handleFilterChange = (key: keyof FilterOptions, value: any) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleReset = () => {
    const resetFilters: FilterOptions = {
      category: 'all',
      accuracy: 0,
      deployment: 'all',
      integration: 'all'
    };
    setFilters(resetFilters);
    onReset();
  };

  return (
    <div className="bg-card rounded-lg shadow-brand border border-border">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon name="Filter" size={20} className="text-primary" />
            <h3 className="text-lg font-semibold text-foreground">Filters</h3>
          </div>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 hover:bg-muted rounded-md transition-colors duration-300"
            aria-label="Toggle filters"
          >
            <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={20} />
          </button>
        </div>
      </div>

      <div className={`p-4 space-y-4 ${isOpen ? 'block' : 'hidden lg:block'}`}>
        <div>
          <Select
            label="Category"
            options={categoryOptions}
            value={filters.category}
            onChange={(value) => handleFilterChange('category', value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Minimum Accuracy: {filters.accuracy}%
          </label>
          <input
            type="range"
            min="0"
            max="100"
            step="5"
            value={filters.accuracy}
            onChange={(e) => handleFilterChange('accuracy', parseInt(e.target.value))}
            className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-primary"
          />
          <div className="flex justify-between text-xs text-text-secondary mt-1">
            <span>0%</span>
            <span>50%</span>
            <span>100%</span>
          </div>
        </div>

        <div>
          <Select
            label="Deployment Timeline"
            options={deploymentOptions}
            value={filters.deployment}
            onChange={(value) => handleFilterChange('deployment', value)}
          />
        </div>

        <div>
          <Select
            label="Integration Type"
            options={integrationOptions}
            value={filters.integration}
            onChange={(value) => handleFilterChange('integration', value)}
          />
        </div>

        <div className="pt-4 border-t border-border space-y-2">
          <Checkbox
            label="Demo Available"
           
            onChange={() => {}}
          />
          <Checkbox
            label="Case Studies Available"
           
            onChange={() => {}}
          />
          <Checkbox
            label="Free Trial"
           
            onChange={() => {}}
          />
        </div>

        <div className="pt-4 space-y-2">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="RotateCcw"
            iconPosition="left"
            onClick={handleReset}
          >
            Reset Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;